/* @flow */

import axios from 'axios';
import qs from 'qs';
import Loading from './Loading';
import manterLogado from './manter-logado';

let active = 0;

const xhr = axios.create({
    transformRequest: [(data: Object) => qs.stringify(data)],
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
    },
    timeout: 30000,
});

export const isActive = () => active > 0;

const mostrarLoad = (load): boolean => typeof load === 'undefined' || load !== false;

const fimDaRequisicaoComErro = (err) => {
    Loading.hide();
    active -= 1;
    return Promise.reject(err);
};


xhr.interceptors.request.use((config) => {
    if (typeof config.load !== 'undefined' && mostrarLoad(config.load)) {
        Loading.show();
    }

    active += 1;
    return config;
}, fimDaRequisicaoComErro);

xhr.interceptors.response.use((response) => {
    const resultado: any = response.data;
    if (typeof response.config.load !== 'undefined' && mostrarLoad(response.config.load)) {
        Loading.hide();
    }

    active -= 1;

    if (typeof resultado.redirecionar !== 'undefined' && resultado.redirecionar) {
        manterLogado(resultado);
        return false;
    }
    return resultado;
}, fimDaRequisicaoComErro);

/**
 * Usar
 * import xhr from ajax
 *
 * xhr.post('url', data).then(function(){
 *      //success
 * })
 */
export default xhr;



// WEBPACK FOOTER //
// ./app/utils/Ajax.js